import { render } from "./AboutS12.vue?vue&type=template&id=05977164&scoped=true"
import script from "./AboutS12.vue?vue&type=script&lang=js"
export * from "./AboutS12.vue?vue&type=script&lang=js"

import "./AboutS12.vue?vue&type=style&index=0&id=05977164&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05977164"]])

export default __exports__